import { ContentBlock } from './content-block';
import { ContentBlockDto } from './content-block.dto';
import { ContentBlockAttachement, ContentBlockImage, ContentBlockParagraph } from './content-blocks';

export class ContentBlockFactory {
    static create(block: ContentBlockDto): ContentBlock {
        switch (block.type) {
            case 'image':
                return new ContentBlockImage(block);
            case 'paragraph':
                return new ContentBlockParagraph(block);
            case 'attaches':
                return new ContentBlockAttachement(block);
            default:
                throw new Error(`Unknown content block type: ${block.type}`);
        }
    }
}
